import { useTranslation } from 'react-i18next'
import useTableContext from './use-table-context'

const useTableTranslation = () => {
  const { t } = useTranslation()
  const { translationKey } = useTableContext()
  return {
    t: (key, defaultValue) =>
      t(`${translationKey ? `${translationKey}.` : ''}${key}`, defaultValue)
  }
}

export default useTableTranslation
